import React from "react";
import "./App.css";
import Home from "./components/Home/Home.jsx";
import About from "./components/About/About.jsx";
import Skills from "./components/Skills/Skils.jsx";
import Project from "./components/Projects/Projects.jsx";
import Contact from "./components/Contactus/Contact.jsx";
import Preloader from "./components/Preloader/Preloader.jsx";
import King from "../src/assests/king.png";
import Queen from "../src/assests/queen.png";
import Canvas from "./ballsParticle";
import { useEffect } from "react";

function App() {
  /* Disable Inspect Or Developer Tools */
  useEffect(() => {
    Canvas();
  }, []);
  document.addEventListener(
    "contextmenu",
    function (event) {
      event.preventDefault();
    },
    false
  );

  const scroll = () => {
    let scroll = window.scrollY;
    if (scroll === 0) {
      document.getElementById("nav-div").classList.remove("onscrollnav");
      document.getElementById("title-span").classList.add("title-span");
      document.getElementById("btn-overlap").classList.remove("oppo");
    } else if (scroll !== 0) {
      document.getElementById("nav-div").classList.add("onscrollnav");
      document.getElementById("btn-overlap").classList.add("oppo");
      document.getElementById("title-span").classList.remove("title-span");
    }
  };
  window.addEventListener("scroll", scroll);

  const navibtn = () => {
    let navi = document.getElementById("nav-mobile-btn-img");
    let navi1 = document.getElementById("nav-component-mobile");
    if (navi.src === King) {
      navi.src = Queen;
      navi1.classList.remove("none");
      navi1.classList.add("nav-component-mobile");
    } else if (navi.src === Queen) {
      navi.src = King;
      navi1.classList.remove("nav-component-mobile");
      navi1.classList.add("none");
    }
  };

  let d = new Date();
  let year = d.getFullYear();

  setTimeout(() => {
    let v = document.getElementById("remove");
    v.classList.add("none");
  }, 3000);

  return (
    <>
      <canvas id="canvas"></canvas>
      <div id="remove" className="">
        <Preloader />
      </div>
      <a href="#home">
        <button className="btn-overlap" id="btn-overlap">
          <i class="arrow up"></i>
        </button>
      </a>
      <nav id="nav">
        <div className="nav-div" id="nav-div">
          <div className="nav-title">
            <h2 id="title-h2">
              Rockst
              <span className="title-span" id="title-span">
                Arjun
              </span>
            </h2>
          </div>
          <div className="nav-component">
            <ul className="nav-ul">
              <a href="#home">
                <li className="nav-li">Home</li>
              </a>
              <a href="#about">
                <li className="nav-li">About</li>
              </a>
              <a href="#skills">
                <li className="nav-li">Skills</li>
              </a>
              <a href="#project">
                <li className="nav-li">Projects</li>
              </a>
              <a href="#contact">
                <li className="nav-li">Contact Me</li>
              </a>
            </ul>
          </div>
          <div className="nav-mobile">
            <button id="nav-mobile-btn" onClick={navibtn}>
              <img src={King} alt="" id="nav-mobile-btn-img" />
            </button>
          </div>
          <div className="none" id="nav-component-mobile">
            <ul className="nav-ul-mobile">
              <a href="#home" onClick={navibtn}>
                <li className="nav-li-mobile">Home</li>
              </a>
              <a href="#about" onClick={navibtn}>
                <li className="nav-li-mobile">About</li>
              </a>
              <a href="#skills" onClick={navibtn}>
                <li className="nav-li-mobile">Skills</li>
              </a>
              <a href="#project" onClick={navibtn}>
                <li className="nav-li-mobile">Projects</li>
              </a>
              <a href="#contact" onClick={navibtn}>
                <li className="nav-li-mobile">Contact us</li>
              </a>
            </ul>
          </div>
        </div>
      </nav>
      <setion></setion>
      <section id="home">
        <Home />
      </section>
      <section id="about">
        <About />
      </section>
      <section id="skills">
        <Skills />
      </section>
      <section id="project">
        <Project />
      </section>
      <section id="contact">
        <Contact />
      </section>

      <footer id="footer">
        <div className="social-media-handle-footer">
          <a
            href="https://github.com/rockstarjun"
            onClick={navibtn}
            target="_blank"
            rel="noreferrer"
          >
            {" "}
            <button id="github" />
          </a>
          <a
            href="https://linkedin.com/in/arjun-chauhan-20b9aa217"
            onClick={navibtn}
            target="_blank"
            rel="noreferrer"
          >
            <button id="linkedin" />
          </a>
          <a
            href="https://instagram.com/python.programe"
            onClick={navibtn}
            target="_blank"
            rel="noreferrer"
          >
            {" "}
            <button id="instagram" />
          </a>
        </div>
        <div className="footer">
          <h3 id="footer-h3">
            © {year} <span className="span-footer">ARJUN CHAUHAN</span>. All
            Rights Reserved
          </h3>
        </div>
      </footer>
    </>
  );
}

export default App;
